import { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// ------ Components ------ //
import SortableFieldList from '../../../components/Miscellaneous/SortableFieldList/SortableFieldList'
// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'
import * as badgeService from '../../../services/badgeManagementService'
import styles from './BadgeTemplateFieldOrdering.module.css'

const BadgeTemplateFieldOrdering = ({ user }) => {
    const location = useLocation()
    const passedState = location.state
    const navigate = useNavigate()
    // state
    const [Field, setField] = useState([])

    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    // --- REST --- //
    const createRequestBody = async () => {

       let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    // useEffect
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName) {
            const fetchData = async () => {
                const getReqBody = await createRequestBody()
                const data = await badgeService.getRegFieldsOrdering(getReqBody)
                const items = Array.from(data)
                setField(items)
            }
            fetchData()
        }

    }, [clientEventInfo])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])

    // functions
    const createSaveRequest = (items) => {
        const fieldsSave = {
            ClientId: clientEventInfo.clientId,
            EventId: clientEventInfo.eventId,
            registrationOrdering: items
        }

        return fieldsSave
    }

    // Persist the new ordering only when the user clicks Save (SortableFieldList).
    const handleSaveOrder = async (orderedItems) => {
        const saveRequest = createSaveRequest(orderedItems)
        await badgeService.saveRegFieldsOrdering(saveRequest)
        setField(orderedItems)
    }

    return (
        <div className="page-area">
            <div className={styles.templateIndex}>
                <h1>Badge Template Field Layout Ordering</h1>
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                <h2>Reorder the fields, then click Save order.</h2>
                <p className={styles.helpText}>
                    Drag the handle, use the up/down arrows, or type a rank in the box to move a field.
                    Search to jump to a field in a long list.
                </p>

                <SortableFieldList
                    items={Field}
                    getId={(item) => item.id}
                    getLabel={(item) => item.cssFieldName}
                    onSave={handleSaveOrder}
                    emptyText="No fields found for this event."
                />

                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            </div>
        </div>
    );
}

export default BadgeTemplateFieldOrdering;
